import React from "react";
import classNames from "classnames";

import { events } from "@planzone/events";
import { UseCases } from "@planzone/core";
import { useEditTask } from "@planzone/view-models";
import { useModal } from "@root/client/modal";
import { useMessage } from "@components/useMessage";
import { VisibilitySwitch } from "@common/visibilitySwitch";
import { Props } from "./types";
import { EditIcon } from "./editIcon";
import styles from "./styles.scss";

function NameEditionForm({ task }: Props) {
  const [name, setName] = React.useState(task.name);
  const { pushView } = useModal();
  const { editTask, isRequestPending } = useEditTask(task);
  const inputRef = React.useRef<HTMLInputElement>(null);

  React.useEffect(() => {
    setName(task.name);
  }, [task.name]);

  useMessage(
    (message) =>
      message.type === events.editTaskFailed &&
      task.uuid === message.data.task.uuid &&
      setName(task.name),
  );

  return (
    <VisibilitySwitch
      renderChildren={(isVisible, show, hide) => (
        <div
          className={classNames(styles.nameEditionForm, {
            [styles.edition]: isVisible,
            [styles.pending]: isRequestPending,
          })}
        >
          <form
            className={styles.form}
            onSubmit={(e) => {
              e.preventDefault();
              editTask({ task, nextTask: { ...task, name } });
              hide();
            }}
          >
            <input
              ref={inputRef}
              className={styles.input}
              value={name}
              onBlur={() => {
                hide();
                setName(task.name);
              }}
              onChange={({ target }) => setName(target.value)}
            />
          </form>
          <div className={styles.name}>
            <h3
              onClick={() =>
                pushView({ key: UseCases.retrieveTask, data: { task } })
              }
            >
              {task.name}
            </h3>
            <div
              onClick={(e) => {
                e.stopPropagation();
                show();
                setTimeout(() => {
                  inputRef.current && inputRef.current.focus();
                });
              }}
            >
              <EditIcon
                className={styles.icon}
                style={{ color: task.status.color }}
              />
            </div>
          </div>
        </div>
      )}
    />
  );
}

export { NameEditionForm };
